import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/sa/digitize.webp";

function BannerText({ rtl }) {
  const className = rtl
    ? "revolution_gcc p-100 rtl-style"
    : "revolution_gcc p-100";
  return (
    <div className={className} style={{ backgroundImage: `url(${BannerImg})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>حلول رقمية مخصصة لعملك</h2>
            <p>
              باعتبارها واحدة من الشركات الرائدة في تصميم تطبيقات الهاتف المحمول
              في جدة، كانت TekRevol في طليعة تمكين الشركات بمنتجات جاهزة للسوق
              وتطبيقات اندرويد وآي أو إس سهلة الاستخدام. تتمتع فرق التطوير
              والتسويق لدينا بمهارات عالية في مساعدة الشركات على زيادة الإنتاجية
              وتعزيز الكفاءة التشغيلية من خلال حلول التنقل القابلة للتطوير.
            </p>
            <p>
              قام مطورو تطبيقات الهاتف المحمول المحترفون لدينا ببناء العديد من
              تطبيقات B2B وB2C مع تجارب مستخدم متميزة. وقد تم ذلك أيضًا من خلال
              دمج الأطر والتقنيات المتطورة مثل الذكاء الاصطناعي والتعلم الآلي
              والأتمتة والواقع المعزز وممارسات الواقع الافتراضي.
            </p>

            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              هيا بنا نبدأ
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default BannerText;
